import Vue from 'ninenine-white-label/Vue'
import Vuex from 'vuex'

import opportunities from 'ninenine-white-label/store/modules/opportunities'
import location from 'ninenine-white-label/store/modules/location'
import user from 'ninenine-white-label/store/modules/user'
import domains from 'ninenine-white-label/store/modules/domains'
import graphql_queries from 'ninenine-white-label/store/modules/graphql_queries'
import tests from 'ninenine-white-label/store/modules/tests'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    opportunities,
    location,
    user,
    domains,
    graphql_queries,
    tests
  },
  state: {
    source: 'carreiras',
    companyId: process.env.VUE_APP_COMPANY_ID,

    bancoDeTalentos: process.env.VUE_APP_BANCO_DE_TALENTOS,

    tkn: `Token token=${process.env.VUE_APP_API_TOKEN}`,

    tkn1: `Token token=${process.env.VUE_APP_API_TOKEN}`,
    tkn2: `Token token=${process.env.VUE_APP_API_TOKEN_2}`,

    deviseForm: null,
    deviseLoading: false,

    deviseTrying: { },

    deviseClosedToReadTerms: { },
    pendingAcceptTerms: false,

    personalDataForm: { },
    educationsForms: [],
    professionalExperiencesForms: [],
    languagesForms: [],
    flag_no_professional_experience: false,
    opportunityQuestionsForm: { },
    indicationForm: { },

    companyName: 'Unipar',

    websiteName: 'Unipar Carreiras',

    areas: [
      {
        "id": 3455,
        "name": "Compras",
      },
      {
        "id": 3464,
        "name": "Engenharia",
      },
      {
        "id": 3454,
        "name": "Finanças",
      },
      {
        "id": 3465,
        "name": "Fiscal e Tributária",
      },
      {
        "id": 3457,
        "name": "Logística",
      },
      {
        "id": 3493,
        "name": "Manutenção",
      },
      {
        "id": 3452,
        "name": "Marketing",
      },
      {
        "id": 3492,
        "name": "Operações",
      },
      {
        "id": 3466,
        "name": "Produção e Fabricação",
      },
      {
        "id": 3456,
        "name": "Qualidade",
      },
      {
        "id": 3453,
        "name": "Recursos Humanos",
      },
      {
        "id": 3459,
        "name": "Serviços Gerais",
      },
      {
        "id": 3467,
        "name": "Suprimentos (Compras)",
      },
      {
        "id": 3468,
        "name": "Tecnologia",
      },
    ],

    teams: [
      {
        "title": "Escritório",
        "slug": "escritorio",
        "coverImage": "banner-escritorio.jpg"
      },
      {
        "title": "Fábrica",
        "slug": "fabrica",
        "coverImage": "banner-fabrica.jpg"
      },
      {
        "title": "Lojas",
        "slug": "lojas",
        "coverImage": "banner-lojas.jpg"
      },
    ],

  },
  getters: {
    basicProfileEmpty: state => {
      const profile = state.user.profile;

      return (
        !profile.nationality || profile.nationality.length == 0 ||
        (
          (!profile.cpf || profile.cpf.length == 0) &&
          (!profile.passport || profile.passport.length == 0)
        ) ||
        !profile.phone || profile.phone.length == 0 ||
        !profile.birthday || profile.birthday.length == 0 ||
        !profile.gender || profile.gender.length == 0 ||
        !profile.raceAndEthnicity || profile.raceAndEthnicity.length == 0 ||
        !profile.pronoun || profile.pronoun.length == 0 ||
        !profile.personalIncome || profile.personalIncome.length == 0 ||
        !profile.location.zipcode || profile.location.zipcode.length == 0 ||
        !profile.location.street || profile.location.street.length == 0 ||
        !profile.location.number || profile.location.number.length == 0 ||
        !profile.location.neighborhood || profile.location.neighborhood.length == 0 ||
        !profile.location.city || profile.location.city.length == 0 ||
        !profile.location.stateId || profile.location.stateId.toString().length == 0
      ) &&
        (!profile.educations || profile.educations.length == 0) &&
        (!profile.professionalExperiences || profile.professionalExperiences.length == 0 || state.flag_no_professional_experience == false)
    }
  },
  mutations: {
    CHANGE_TKN(state, payload){
      state.tkn = payload;
    },
    DEVISE_FORM(state, payload) {
      state.deviseForm = payload;
    },
    DEVISE_LOADING(state, payload) {
      state.deviseLoading = payload;
    },
    DEVISE_TRYING(state, payload) {
      state.deviseTrying = payload == null ? { } : payload;
    },
    DEVISE_DEVISE_CLOSED_TO_READ_TERMS(state, payload) {
      state.deviseClosedToReadTerms = payload == null ? { } : payload;
    },
    SET_PENDING_ACCEPT_TERMS(state, payload) {
      state.pendingAcceptTerms = payload;
    },
    PERSONAL_DATA_FORM(state, payload) {
      state.personalDataForm = payload;
    },
    EDUCATIONS_FORMS(state, payload) {
      if (!payload) {
        state.educationsForms = []
      } else {
        if (state.educationsForms.find(form => form._uid == payload._uid)) {
          state.educationsForms[state.educationsForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.educationsForms.push(payload);
        }
      }
    },
    PROFESSIONAL_EXPERIENCES_FORMS(state, payload) {
      if (!payload) {
        state.professionalExperiencesForms = []
      } else {
        if (state.professionalExperiencesForms.find(form => form._uid == payload._uid)) {
          state.professionalExperiencesForms[state.professionalExperiencesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.professionalExperiencesForms.push(payload);
        }
      }
    },
    LANGUAGES_FORMS(state, payload) {
      if (!payload) {
        state.languagesForms = []
      } else {
        if (state.languagesForms.find(form => form._uid == payload._uid)) {
          state.languagesForms[state.languagesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.languagesForms.push(payload);
        }
      }
    },
    SET_FLAG_PROFESSIONAL_EXPERIENCE(state, payload) {
      state.flag_no_professional_experience = payload
    },
    OPPORTUNITY_QUESTIONS_FORM(state, payload) {
      state.opportunityQuestionsForm = payload
      localStorage.setItem('opportunity_questions', JSON.stringify(payload))
    },
    INDICATION_FORM(state, payload) {
      state.indicationForm = payload
      localStorage.setItem('indication_form', JSON.stringify(payload))
    }
  },
  actions: {}
});
